import React from 'react';
import { TagPickerItem, adaptItemForQuickSearchTag } from './GenericTagPicker.types';
import { ISearchOptionsProps } from './QuickSearchTag';
import { tagPickerStyles } from './GenericTagPicker.styles';

interface DefaultOptionRendererProps<T extends TagPickerItem> {
    item: T;
    hideCoin?: boolean;
    customAvatar?: (option: ISearchOptionsProps) => React.JSX.Element;
}

export const DefaultOptionRenderer = <T extends TagPickerItem>({
    item,
    hideCoin = false,
    customAvatar
}: DefaultOptionRendererProps<T>) => (
    <div style={tagPickerStyles.defaultOption.container}>
        {!hideCoin && (
            <div>
                {customAvatar ?
                    customAvatar(adaptItemForQuickSearchTag(item)) :
                    <div style={tagPickerStyles.defaultOption.avatar}>
                        {item.displayText.charAt(0).toUpperCase()}
                    </div>
                }
            </div>
        )}
        <div style={tagPickerStyles.defaultOption.textContainer}>
            <div style={tagPickerStyles.defaultOption.primaryText}>
                {item.displayText}
            </div>
            {item.secondaryText && (
                <div style={tagPickerStyles.defaultOption.secondaryText}>
                    {item.secondaryText}
                </div>
            )}
        </div>
    </div>
);

export default DefaultOptionRenderer;
